"use client";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

// Simplified version of the Aceternity UI Sparkles component
export const SparklesCore = ({
  id,
  className,
  background = "transparent",
  minSize = 0.4,
  maxSize = 1,
  speed = 1,
  particleColor = "#FFF",
  particleDensity = 100,
}) => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const particleCount = Math.min(particleDensity, 150); // Limit max particles
    const newParticles = [];

    for (let i = 0; i < particleCount; i++) {
      newParticles.push({
        id: i,
        x: Math.random() * 100, // Random x position (0-100%)
        y: Math.random() * 100, // Random y position (0-100%)
        size: minSize + Math.random() * (maxSize - minSize),
        duration: 1 + Math.random() * 3 * (1 / speed), // Random duration based on speed
        delay: Math.random() * 2, // Random delay for animation
      });
    }

    setParticles(newParticles);
  }, [minSize, maxSize, speed, particleDensity]);

  return (
    <div
      id={id}
      className={cn("w-full h-full absolute inset-0", className)}
      style={{
        background,
      }}
    >
      {particles.map((particle) => (
        <motion.div
          key={particle.id}
          className="absolute rounded-full opacity-0"
          style={{
            top: `${particle.y}%`,
            left: `${particle.x}%`,
            width: `${particle.size * 4}px`,
            height: `${particle.size * 4}px`,
            backgroundColor: particleColor,
          }}
          animate={{
            opacity: [0, 0.5, 0],
            scale: [0, 1, 0],
          }}
          transition={{
            duration: particle.duration,
            repeat: Infinity,
            delay: particle.delay,
            ease: "easeInOut",
          }}
        />
      ))}
    </div>
  );
};
